import React, {useState} from "react";
//import P_show from "./P_show"

//let show = false;





const TimeLineItem = ({data}) => {


  const [visible, setVisibel] = useState(false);
  const visibileHandler = () => {
    setVisibel(!visible)
  }

  return(

  

  <div className="timeline-item">
    <div className="timeline-item-content">

      {data.category ? <span className="tag" 
            style={{background: data.category.color}}>
            {data.category.tag}
      </span> :null}
      
      <time>{data.date}</time>
      <hr className="hr_long"></hr>

      <h2>{data.head}</h2>
     

      
      {visible === true && data.text ?
      
      <div className="LastItem">
      
      <p>{data.text}</p>

        {data.text_list ? 
        <div style={{margin: "20px"}}>       
        {data.text_list.map((items, index) => 
          <li key={index}>{items}</li>)}
        </div>
        :null} {/* Map Items */}
      


      {data.link && <a href={data.link.url}
                          target="_blank"
                          rel="noopener noreferrer">
                          {data.link.text}
                        </a>}
      </div>
      : null} {/* Link Reference if available */}

      {data.text ? 
      <button className="Button_Timeline_Info" onClick={visibileHandler}>
        {visible == false ? "more info" : "less info"}
        </button>
        : null} {/* Toggle Button */}

      <span className="circle"></span>
    </div>
  </div>
)
  }

export default TimeLineItem